import type * as Stitches from "@stitches/react";
import { styled } from "src/ccl/stitches";

export const Flex = styled("div", {
  boxSizing: "border-box",
  display: "flex",
});

export type FlexProps = Stitches.ComponentProps<typeof Flex>;
